module.exports = __webpack_public_path__ + "static/crowdfunding-f403d2c142cb20754e5f6860fc02ebd9.png";